<template>

	<span v-if="loaded == 'true'">

		<img v-if="LaCat.categoria_meta.imagen_grande" v-bind:src="LaCat.categoria_meta.imagen_grande.sizes['1440x446']" width="100%">
		<img v-else v-bind:src="theme_url+'/html/assets/img/slide-1.jpg'" width="100%">

		<div class="col-xs-12 npd block novedades" >
			<h2>{{ catName }}</h2>
				<ul class="col-xs-12 filtro" v-if="loaded_categorias=='true'">
					<li>
						<router-link :to="{ name: 'allcats' }" >
							Todos
						</router-link>
					</li>
					<li v-for="categoria in categorias" class="_active">
						<router-link v-if="categoria.slug!='podcast'" :to="{ name: 'cat', params: { name:categoria.slug } }" >
							{{ categoria.name }}
						</router-link>
						<!-- <router-link v-else :to="{ name: 'catpodcast' }" >
							{{ categoria.name }}
						</router-link> -->

					</li>
				</ul>
			<section class="col-xs-12 npd novedades__bloque">
				<div class="container">
					<div class="row">

						<div class="col-xs 12">

							<div class="col-xs-6 col-md-3" v-for="post in posts">
								<router-link :to="{ name: 'post', params: { name:post.slug }}">
									<figure v-if="post.better_featured_image != null">
										<img v-if="post.better_featured_image.media_details.sizes.hasOwnProperty('536x516')" v-bind:src="post.better_featured_image.media_details.sizes['536x516'].source_url" />
										<img v-else v-bind:src="post.better_featured_image.source_url" />
									</figure>
									<figure v-else>
										<img v-bind:src="'http://via.placeholder.com/536x516/008AD2/dddddd?text='+post.title.rendered" alt="">
									</figure>
									<h3 v-html="post.title.rendered"> </h3>
									<p v-html="post.excerpt.rendered"> </p>
								</router-link>
							</div>

						</div>
					</div>
				</div>



				<div class="col-md-12">

					<nav aria-label="Page navigation" v-if="totalPages > 1">
						<ul class="pagination">
							<li v-on:click="rtShowFirst()" id="rtShowFirst">
								&laquo;&laquo;
							</li>
							<li v-if="showPrev=='true'" v-on:click="rtShowPrev()" id="rtShowPrev">
								&laquo;
							</li>
							<li>
								{{ currentPage }} - {{ totalPages }}
							</li>
							<li v-if="showNext=='true'" v-on:click="rtShowNext()" id="rtShowNext">
								&raquo;
							</li>
							<li v-on:click="rtShowLast()" id="rtShowLast">
								&raquo;&raquo;
							</li>
						</ul>
					</nav>
				</div>

			</section>
		</div>


	</span>

</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		if ( vm.$route.params.name ) {
			vm.getCatId( vm.$route.params.name );
		}
		vm.getCats();
	},
	watch: {
		// call method if the route changes
		'$route': 'reInitialize'
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			posts: {},
			loaded: 'false',
			loaded_categorias: 'false',
			pageTitle: '',
			totalCount: '',
			catName: '',
			LaCat: '',
			categorias:{},
			currentPage: '',
			prevPage: '',
			nextPage: '',
			showNext: 'false',
			showPrev: 'false',
			postPerPage: '12',
			totalPages: '',
		};
	},
	methods: {
		reInitialize: function() {
			this.getCatId( this.$route.params.name );
			this.getCats();
		},
		getPosts: function( catId, pageNumber = 1 ) {
			const vm = this;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, page: pageNumber,per_page: vm.postPerPage }
			} )
			.then( ( res ) => {
				vm.posts = res.data;
				vm.loaded = 'true';
				vm.totalPages = res.headers[ 'x-wp-totalpages' ];
				console.log('Paginas: '+res.headers[ 'x-wp-totalpages' ]);
				vm.showNext='true';
				vm.showPrev='true';
				if ( pageNumber <= parseInt( vm.totalPages ) ) {
					vm.currentPage = parseInt( pageNumber );
				} else {
					vm.currentPage = 1;
				}
				vm.$nextTick(function(){
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getCatId: function( name ) {
			const vm = this;
			vm.catName = name;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/categories/?slug=' + name )
			.then( ( res ) => {
				vm.totalCount = (res.count);
				res = res.data[ 0 ];
				vm.catName=res.name;
				vm.pageTitle = vm.catName;
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				vm.getPosts( res.id, 1 );
				vm.LaCat=res;
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		rtShowNext: function( event ) {
			const vm = this;
			if ( vm.currentPage < vm.totalPages ) {
				vm.currentPage = vm.currentPage + 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowPrev: function( event ) {
			const vm = this;
			if ( vm.currentPage != 1 ) {
				vm.currentPage = vm.currentPage - 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowFirst: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,1);
		},
		rtShowLast: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,vm.totalPages);
		},
		getCats:function (){
			// http://104.236.216.165/wp-json/wp/v2/categories/
			const vm = this;
			vm.loaded_categorias = 'false';
			vm.$http.get( 'wp/v2/categories/', {
				params: { hide_empty: true, parent:0 }
			} )
			.then( ( res ) => {
				vm.loaded_categorias='true';
				vm.categorias=res.data;
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		}
	},
};
</script>



// WEBPACK FOOTER //
// category.vue?35b364a7